import { render, staticRenderFns } from "./modalInformacionPago.vue?vue&type=template&id=ec4a9854&"
import script from "./modalInformacionPago.vue?vue&type=script&lang=js&"
export * from "./modalInformacionPago.vue?vue&type=script&lang=js&"
import style0 from "./modalInformacionPago.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ec4a9854')) {
      api.createRecord('ec4a9854', component.options)
    } else {
      api.reload('ec4a9854', component.options)
    }
    module.hot.accept("./modalInformacionPago.vue?vue&type=template&id=ec4a9854&", function () {
      api.rerender('ec4a9854', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/dte/componentes/acciones/modales/modalInformacionPago.vue"
export default component.exports